<div id="value-zone-filters">
  <div class="row">
    <p class="title">Zonas de valor</p>
    <a class="clean-filters">Limpar</a>
  </div>

  <lib-button-tertiary (click)="showModal=true">Adicionar</lib-button-tertiary>
</div>

<div class="modal" *ngIf="showModal == true">

  <div class="bg" (click)="showModal=false"></div>

  <div class="content filter">
    <div class="row">
      <p class="title">Filtro de bairros e regiões</p>
      <a class="close" (click)="showModal=false">&times;</a>
    </div>
    <div class="row">
      <app-input class="one-third" id="estado" label="Estado" placeholder="">
      </app-input>
    </div>
    <div class="row">
      <app-input class="one-third" id="regiao" label="Região" placeholder="">
      </app-input>
      <app-input class="one-third" id="zona" label="Zona de valor" placeholder="">
      </app-input>
      <app-input class="one-third" id="bairro" label="Bairro" placeholder="">
      </app-input>
    </div>

    <div class="row buttons">
      <lib-button-tertiary (click)="showModal=false">Cancelar</lib-button-tertiary>
      <lib-button-primary>Adicionar</lib-button-primary>
    </div>
  </div>
</div>